import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";

const React = require('react');
const Link = require('react-router-dom').Link;
const Utils = require('../utils');
const SharedConstants = require('../../../../shared/sharedConstants');
const SharedModels = require('../../../../shared/sharedModels');
const connect = require('react-redux/dist/react-redux.min.js').connect;
const Avatar = require('./commonControls.jsx').userAvatar;
const ReduxStore = require('./../redux/reduxStore.jsx.js');
const AjaxFunctions = require('../ajaxFunctions');
const BadgeRow = require('../components/badgeRow.jsx').BadgeRow;
import Toastr from 'toastr';
import Switch from "@material-ui/core/Switch/Switch";
import Chip from '@material-ui/core/Chip';
import { UserAvatarV2 } from "./commonControls.jsx";
import { GridList, Typography, GridListTile, Button, List, ListItem } from "@material-ui/core";

class UserDetailsBase extends React.Component {
   constructor(props) {
      super(props);
   }

   followOrUnfollowUser() {
      AjaxFunctions.followUser(this.props.user.id).then((data) => {
         ReduxStore.store.dispatch(ReduxStore.UserFunctions.setIsCurrentUserFollowing(data));
      }, (err) => {
         Toastr.options.positionClass = 'toast-bottom-full-width';
         Toastr.error(err);
      })
   }


   render() {

      let actionButtons = () => {
         if (this.props.user.id === this.props.loggedInUser.id) {
            return (
               <Button component={Link} to={'/editProfile'} variant='outlined' className="material-button" fullWidth style={{ marginBottom: '10px' }}>Edit Profile</Button>
            )
         }
         else if (window.globals.idUser) {
            return (
               <div>
                  <Button onClick={() => this.followOrUnfollowUser()} variant='outlined'
                     className="material-button" fullWidth style={{ marginBottom: '10px' }}>{this.props.isCurrentUserFollowing ? 'Unfollow' : 'Follow'}</Button>
                  <Button component={Link} to={`/messages?idCorrespondent=${this.props.user.id}`} onClick={() => this.props.setCorrespondent(new SharedModels.User({ id: this.props.user.id }))}
                     variant='outlined' className="material-button" fullWidth style={{ marginBottom: '10px' }}>Message</Button>
               </div>
            )
         }
         return null;
      };
      let pointAwards = <ul>{
         this.props.user.pointAwards.map((pa, idx) => {
            return (
               <li key={idx}>
                  <div key={pa.idPointAward}>
                     {pa.value} points for {pa.templatedText ? pa.templatedText : pa.text}
                  </div>
               </li>
            )
         })
      }</ul>;

      let { user } = this.props;
      return (
         <div>
            <div style={{ textAlign: 'center' }}>
               <div style={{ display: 'inline-block', marginBottom:'10px' }}>
                  <UserAvatarV2 size="large" userData={user}></UserAvatarV2>
               </div>
               <br />
               {this.props.showName && <Typography color='primary' style={{ fontWeight: '600px', fontSize: '18px', marginBottom: '10px' }}>
                  {this.props.user.firstName ? `${this.props.user.firstName} ${this.props.user.lastName}` : ''}
               </Typography>}
               <BadgeRow badges={user.achievements} />
               {this.props.showActionButtons && actionButtons()}
            </div>
            <div style={{ textAlign: 'center' }}>
               <GridList cellHeight={70} cols={2}>
                  <GridListTile cols={1}>
                     <Typography color='primary' style={{ fontWeight: '600px', fontSize: '18px' }}>
                        Points
               </Typography>
                     <Typography style={{ fontWeight: '600px', fontSize: '16px' }}>
                        {user.points}
                     </Typography>
                  </GridListTile>
                  <GridListTile cols={1}>
                     <Typography color='primary' style={{ fontWeight: '600px', fontSize: '18px' }}>
                        Level
               </Typography>
                     <Typography style={{ fontWeight: '600px', fontSize: '16px' }}>
                        {Utils.calculateUserLevel(user.points)}
                     </Typography>
                  </GridListTile>
               </GridList>
            </div>
            <div>
               {user.expertise.length > 0 && <Typography style={{ fontWeight: '600', fontSize: '16px', marginBottom: '10px' }}>
                  Expertise
         </Typography>}
               {user.expertise.map(exp =>        
               <Chip
                  variant='outlined'
                  key={exp.id}
                  label={<Typography style={{whiteSpace: 'normal', fontSize: '14px'}}>{exp.name}</Typography>}
                  style={{height:"100%", marginRight: 5, marginBottom: 10}}
                  color="primary"
               />
               )}
               {user.interest.length > 0 && <Typography style={{ fontWeight: '600', fontSize: '16px', marginBottom: '10px' }}>
                  Interests
         </Typography>}
               {user.interest.map(exp => 
                  <Chip
                  variant='outlined'
                  key={exp.id}
                  label={<Typography style={{whiteSpace: 'normal', fontSize: '14px'}}>{exp.name}</Typography>}
                  style={{height:"100%", marginRight: 5, marginBottom: 10}}
                  color="primary"
               />)}
               <Typography style={{ fontWeight: '600', fontSize: '16px', marginBottom: '10px' }}>
                  Latest Spark Awards
         </Typography>
               <div className="tags">
                  {pointAwards}
               </div>
            </div>
         </div>
      )
   }
}

const mapUserDetailsStateToProps = (state) => {
   return {
      user: state.UserReducer.targetUser,
      loggedInUser: state.UserReducer.curUser,
      isCurrentUserFollowing: state.UserReducer.isCurrentUserFollowing
   }
};

const mapUserDetailsDispatchToProps = (dispatch) => {
   return {
      setCorrespondent: (correspondent) => {
         dispatch(ReduxStore.MessageFunctions.setCorrespondent((correspondent)));
      },
   }
};

export default connect(
   mapUserDetailsStateToProps,
   mapUserDetailsDispatchToProps
)(UserDetailsBase);


class TopicList extends React.Component {
   constructor(props) {
      super(props);
   }

   render() {
      let topicButtons = this.props.listItems.map((item) => {
         return (
            <Chip
               style={{ marginRight: 5, marginBottom: 5 }}
               key={item.id}
               label={item.name}
               color="primary"
            />
         )
      });
      return (
         <div className="side-section">
            <div className="section-title">{this.props.title}</div>
            <div className="tags">
               {topicButtons}
            </div>
         </div>
      );
   }
}